import { idtype } from "querypieces";

export default `
  programValues {
    ...on programValuesItem_Entry {
      ${idtype}
      heading
      plainText
    }
  }
`;
